<template>
    <div style="margin-top: 10px">
        <div v-if="state.registrantData.total > 0">

            <h4 style="text-align: left">Payment</h4>
            <hr>
            <div class="credit-card-wrapper"></div>
            <form id="payment-form">
                <div class="row">
                    <div class="col-sm-12">
                        <input placeholder="Card number" type="text" name="number" id="number"
                               v-model="state.registrantData.ccInfo.number" style="border-radius: 5px">
                    </div>
                </div>
                <div class="row">
                    <div class="col">

                        <input placeholder="First Name" type="text" name="first-name" id="first-name"
                               v-model="state.registrantData.ccInfo.firstName" style="border-radius: 5px 0 0 5px">
                    </div>
                    <div class="col">
                        <input placeholder="Last Name" type="text" name="last-name" id="last-name"
                               v-model="state.registrantData.ccInfo.lastName">
                    </div>
                    <div class="col">
                        <input placeholder="Billing Zip" type="text" name="zip" id="zip"
                               v-model="state.registrantData.ccInfo.zip" style="border-radius: 0 5px 5px 0">
                    </div>
                </div>
                <div class="row">
                    <div class="col col-sm-3">
                        <input placeholder="MM/YY" type="text" name="expiry" id="expiry"
                               v-model="state.registrantData.ccInfo.expiry" style="border-radius: 5px 0 0 5px">
                    </div>

                    <div class="col col-sm-3">
                        <input placeholder="CVV" type="text" name="cvv" id="cvv"
                               v-model="state.registrantData.ccInfo.cvv">
                    </div>

                    <div v-if="formReady.cc && formReady.form && formReady.terms && state.formstate.signature && formReady.promoEmailReady && formReady.freeRegReady"
                         class="col col-sm-6">
                        <input type="button" :value="payButtonTotal" @click="submitPayment"
                               class="button postfix btn-success" style="border-radius: 0 5px 5px 0">
                    </div>
                    <div v-else class="col col-sm-6">
                        <input type="button" :value="payButtonTotal" @click="formNotComplete"
                               class="button postfix btn-danger" style="border-radius: 0 5px 5px 0">
                    </div>
                </div>
            </form>
        </div>
        <div v-else>
            <div v-if="formReady.form && formReady.terms && state.formstate.signature && formReady.freeRegReady">
                <button v-if="!state.loading" class="btn" @click="submitPayment">Place Order</button>
                <button v-else class="btn" disabled>Place Order</button>
            </div>
            <div v-else>
                <button class="btn btn-danger" @click="formNotComplete">Place Order</button>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'

    var card = require('card');

    export default {
        name: 'Payment',
        computed: {
            ...mapGetters({
                state: 'getState',
            }),
            formReady: function () {


                if(this.state.registrantData.regType.price){
                    let regGroups = this.state.registrantData.regType.extraFieldGroupsRequired;
                    let formValid = true;
                    let checkAry = [];

                    regGroups.filter((group) => {
                        if(group === 'trainee' && !this.state.registrantData.proof.name){
                            formValid = false
                        }
                        let item = {
                            group: group,
                            valid: this.state.formstate[group].$valid
                        };
                        checkAry.push(item);
                        if (!this.state.formstate[group].$valid) {
                            formValid = false
                        }
                    });


                    let ccValid = true;
                    if (!this.state.registrantData.ccInfo.number || !this.state.registrantData.ccInfo.expiry || !this.state.registrantData.ccInfo.firstName
                        || !this.state.registrantData.ccInfo.expiry || !this.state.registrantData.ccInfo.lastName || !this.state.registrantData.ccInfo.cvv
                        || !this.state.registrantData.ccInfo.zip) {
                        ccValid = false
                    }

                    let promoEmailReady = true;

                    if(this.state.registrantData.promoReferEmailRequired){
                        if(!this.state.registrantData.promoReferEmail){
                            promoEmailReady = false;
                        }
                    } else{
                        promoEmailReady = true;
                    }

                  let freeRegReady = true;

/*                  if(this.state.registrantData.freeRegEligibiltyRequired){
                    if(!this.state.formstate.reg_eligibilty){
                      freeRegReady = false;
                    }
                  } else{
                    freeRegReady = true;
                  }*/


                    return {
                        form: formValid,
                        cc: ccValid,
                        terms: this.state.formstate.terms,
                        promoEmailReady: promoEmailReady,
                        freeRegReady: freeRegReady
                    };


                }
                else{
                    return {
                        form: false,
                        cc: false,
                        terms: false,
                    };
                }


            },
            payButtonTotal() {
                let output = this.state.registrantData.total;
                output = 'Pay $' + output;
                return output
            }
        },
        methods: {
            submitPayment() {
                console.log('here');
                this.$store.dispatch('sendRequest');
            },
            formNotComplete() {
                alert('Either some form information is incomplete, the terms and conditions have not yet been agreed to or you have not signed the signature box. Please double check for any errors or missing information.')
            }
        },
        mounted: function () {
            var $ = require('jquery');
            window.jQuery = $;

            var card = new Card({
                // a selector or DOM element for the form where users will
                // be entering their information
                form: '#payment-form', // *required*
                // a selector or DOM element for the container
                // where you want the card to appear
                container: '.credit-card-wrapper', // *required*
                formSelectors: {
                    numberInput: 'input#number', // optional — default input[name="number"]
                    expiryInput: 'input#expiry', // optional — default input[name="expiry"]
                    cvcInput: 'input#cvv', // optional — default input[name="cvc"]
                    nameInput: 'input[name="first-name"], input[name="last-name"]' // optional - defaults input[name="name"]
                },
                width: 300, // optional — default 350px
                formatting: true, // optional - default true
                // Strings for translation - optional
                messages: {
                    validDate: 'valid\ndate', // optional - default 'valid\nthru'
                    monthYear: 'mm/yyyy', // optional - default 'month/year'
                },
                // Default placeholders for rendered fields - optional
                placeholders: {
                    number: '•••• •••• •••• ••••',
                    name: 'Full Name',
                    expiry: '••/••',
                    cvc: '•••'
                },
                masks: {
                    cardNumber: '' // optional - mask card number
                },
                // if true, will log helpful messages for setting up Card
                debug: false // optional - default false
            })
        },
    }
</script>

<style scoped>
/* Payment heading */
h4 {
  margin: 0 0 14px;
  padding: 16px 20px;

  background: linear-gradient(
      110deg,
      #148f94 0%,
      #427f9e 50%,
      #656dac 100%
  );

  border-bottom: 3px solid #80c9c5;
  border-radius: 0;

  color: #ffffff;
  font-family: inherit;
  font-weight: 300;
  line-height: 1.35;
  letter-spacing: 0.025em;
  text-transform: uppercase;
}

hr {
  height: 1px;
  margin: 16px 0;
  border: 0;

  background: linear-gradient(
      to right,
      #80c9c5,
      #d9deef
  );
}



/* Payment form panel */
#payment-form {
  box-sizing: border-box;
  padding: 22px;

  background: linear-gradient(
      135deg,
      #edf8f6 0%,
      #f0f1fa 100%
  );

  border: 1px solid #d5e1ea;
  border-radius: 0;
  box-shadow: 0 6px 20px rgba(49, 75, 111, 0.08);

  color: #535c98;
}

/* Payment rows with no spacing between fields */
#payment-form > .row {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0;
  margin: 0;
}

#payment-form > .row:first-child {
  grid-template-columns: minmax(0, 1fr);
}

#payment-form > .row:last-child {
  grid-template-columns:
        minmax(0, 1fr)
        minmax(0, 1fr)
        minmax(0, 2fr);
}

#payment-form div[class*=col] {
  width: auto;
  min-width: 0;
  max-width: none;
  margin: 0;
  padding-left: 0;
  padding-right: 0;
}

/* Payment inputs */
#payment-form input[type="text"] {
  -webkit-appearance: none;
  -moz-appearance: none;

  border-radius: 0 !important;
  background-color: #ffffff;
  border-style: solid;
  border-width: 1px;
  border-color: #bdcddb;

  -webkit-box-shadow: inset 0 1px 3px rgba(49, 75, 111, 0.04);
  box-shadow: inset 0 1px 3px rgba(49, 75, 111, 0.04);

  color: #535c98;
  display: block;
  font-family: inherit;
  font-size: 0.875rem;
  font-weight: 400;

  height: auto;
  min-height: 48px;
  margin: 0;
  padding: 12px 14px;
  width: 100%;
  line-height: 1.5;

  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;

  transition:
      border-color 0.18s ease,
      background-color 0.18s ease,
      box-shadow 0.18s ease;
}

#payment-form input[type="text"]::placeholder {
  color: #737ca2;
  opacity: 1;
}

#payment-form input[type="text"]:hover {
  border-color: #8faebf;
}

#payment-form input[type="text"]:focus {
  position: relative;
  z-index: 3;
  outline: none;
  background-color: #ffffff;
  border-color: #168b91;
  box-shadow: 0 0 0 3px rgba(22, 139, 145, 0.15);
}

/* Payment button */
.postfix.button {
  box-sizing: border-box;
  display: block;
  border: none;
  margin: 0;
  padding: 12px 18px;
  text-align: center;
  font-family: inherit;
  font-size: 0.875rem;
  font-weight: 600;

  height: auto;
  min-height: 48px;
  line-height: 1.5;
  overflow: visible;
  width: 100%;
  z-index: 2;

  border-radius: 0 !important;
  white-space: normal;
}

/* Payment and Place Order buttons */
.postfix.button,
.btn {
  background: linear-gradient(
      110deg,
      #167b83 0%,
      #5866a3 100%
  );

  border: 0;
  color: #ffffff;
  box-shadow: 0 4px 12px rgba(56, 92, 130, 0.20);
  cursor: pointer;

  transition:
      filter 0.18s ease,
      box-shadow 0.18s ease;
}

.btn {
  max-width: 100%;
  min-height: 48px;
  padding: 12px 24px;
  border-radius: 0;

  font-family: inherit;
  font-weight: 600;
  line-height: 1.5;
  white-space: normal;
}

/* Incomplete-form visual state */
.postfix.button.btn-danger,
.btn.btn-danger {
  background: linear-gradient(
      110deg,
      #b94e63 0%,
      #93496e 100%
  );

  color: #ffffff;
  box-shadow: 0 4px 12px rgba(155, 66, 91, 0.18);
}

.postfix.button:hover,
.btn:not(:disabled):hover {
  filter: brightness(0.92);
  color: #ffffff;
  box-shadow: 0 6px 16px rgba(56, 92, 130, 0.25);
}

.postfix.button:focus-visible,
.btn:focus-visible {
  outline: 3px solid #606fac;
  outline-offset: 4px;
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  box-shadow: none;
}

/* Smaller devices */
@media (max-width: 767px) {
  #payment-form > .row,
  #payment-form > .row:last-child {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  #payment-form > .row:first-child {
    grid-template-columns: minmax(0, 1fr);
  }

  #payment-form > .row:nth-child(2) > div:last-child,
  #payment-form > .row:last-child > div:last-child {
    grid-column: 1 / -1;
  }
}

@media (max-width: 480px) {
  h4 {
    padding: 14px 16px;
  }

  .credit-card-wrapper {
    padding: 16px 8px;
  }

  #payment-form {
    padding: 14px;
  }

  #payment-form > .row:nth-child(2) {
    grid-template-columns: minmax(0, 1fr);
  }

  .btn {
    width: 100%;
  }
}
</style>
